<div class="div-container"
     [ngClass]="{'invalid': this.field.formControl?.touched && to.required && count === 0}">

  <p *ngIf="this.to.required == false" class="optional-field">
    (Optional)
  </p>

  <!-- No x value. See US 109647-->
  <ng-container *ngIf="this.dataSourceX.length <= 0; else withXValues">
    <ng-container *ngIf="singleChoice; else multipleChoice">
      <ds-select-field
        [helpertext]="this.to.helperText"
        [label]="this.to.labelY"
        name="single-y"
        placeholder="Select from list"
        (dsSelectChange)="onSingleSelectChange('', $event)"
      >
        <ds-menu-item *ngFor="let y of this.dataSourceY" value="{{y.key}}|">
          {{ y.value.name }}
          <p class="text-light text-small">{{ y.value.description | removeHtmlTags }}</p>
        </ds-menu-item>
      </ds-select-field>
    </ng-container>
    <ng-template #multipleChoice>
      <div class="d-flex flex-row align-items-center">
        <ds-hybrid-field
          id="hybrid"
          [helpertext]="this.to.helperText"
          [label]="this.to.labelY"
          name="multi-y"
          placeholder="Select from list"
          multiple
          (dsHybridFieldSelect)="onMultiSelectChange('', $event)"
        >
          <ds-menu-item *ngFor="let y of this.dataSourceY" value="{{y.key}}|">
            {{ y.value.name }}
            <p class="text-light text-small">{{ y.value.description | removeHtmlTags }}</p>
          </ds-menu-item>
        </ds-hybrid-field>
        <ds-row class="ml-24">
          <ds-col span="12">
            <label class="d-flex">
              <ds-toggle
                name="select-all"
                [value]="this.to.labelY"
                [checked]="allSelectedByX | AreAllYSelected : ''"
                class="d-flex mr-16"
                (dsToggleChange)="onSelectAllChanged('', $event)"></ds-toggle>
              All
            </label>
          </ds-col>
        </ds-row>
      </div>
    </ng-template>
  </ng-container>


  <ng-template #withXValues>
    <ng-container *ngFor="let x of this.dataSourceX">
      <ng-container *ngIf="singleChoice; else multipleChoice">
        <ds-select-field
          [helpertext]="this.to.helperText"
          [label]="x.value.name"
          name="single-y"
          placeholder="Select from list"
          (dsSelectChange)="onSingleSelectChange(x.key, $event)"
        >
          <ds-menu-item *ngFor="let y of this.dataSourceY" value="{{ y.key }}|{{ x.key }}">
            {{ y.value.name }}
            <p class="text-light text-small">{{ y.value.description | removeHtmlTags }}</p>
          </ds-menu-item>
        </ds-select-field>
      </ng-container>
      <ng-template #multipleChoice>
        <div class="d-flex flex-row align-items-center">
          <ds-hybrid-field
            id="hybrid_{{x.key}}"
            [helpertext]="this.to.helperText"
            [label]="x.value.name"
            name="hybrid_{{x.key}}"
            placeholder="Select from list"
            multiple
            (dsHybridFieldSelect)="onMultiSelectChange(x.key, $event)"
          >
            <ds-menu-item *ngFor="let y of this.dataSourceY" value="{{ y.key }}|{{ x.key }}">
              {{ y.value.name }}
              <p class="text-light text-small">{{ y.value.description | removeHtmlTags }}</p>
            </ds-menu-item>
          </ds-hybrid-field>
          <ds-row class="ml-24">
            <ds-col span="12">
              <label class="d-flex">
                <ds-toggle
                  id="toggle_{{x.key}}"
                  name="toggle_{{x.key}}"
                  [checked]="allSelectedByX | AreAllYSelected : x.key"
                  class="d-flex mr-16"
                  (dsToggleChange)="onSelectAllChanged(x.key, $event)">
                </ds-toggle>
                All
              </label>
            </ds-col>
          </ds-row>
        </div>
      </ng-template>
      <div class="mb-40"></div>
    </ng-container>
  </ng-template>

</div>
